import { useEffect } from "react";
import { useNavigate } from "react-router";

import { capture } from "../capture.ts";
import { Splash } from "../ui/primitives.tsx";

/**
 * Where Google sends the browser back. The session cookie is already set;
 * Root's own bootstrap reads it, so this waits for that answer instead of
 * asking the server a second time.
 */
export function AuthSuccessPage({ signedIn }: { signedIn: boolean | null }) {
	const navigate = useNavigate();
	useEffect(() => {
		if (signedIn === null) return;
		if (signedIn) capture("oauth_completed", { provider: "google" });
		navigate(signedIn ? "/" : "/auth/failure", { replace: true });
	}, [signedIn]);
	return <Splash />;
}
